var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import useApiConfig from './useApiConfig';
import { LOYALTY_OFFER_TYPES_SET } from '../../components/PaymentCalculator/ViewOffers/constants';
import { selectCanUseLoyalty } from '../reducers/offerOptions';
import { useAppSelector } from '../utils';
import { useGetOffersQuery, useGetOffersWithLoyaltyQuery } from '../apis/hondaRestApi';
import { usePageState } from '../../utils/sitecoreContext';
export var useFetchOffers = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var transmissionIds = _a.transmissionIds, currentTransmissionId = _a.currentTransmissionId, paymentMethod = _a.paymentMethod, _k = _a.shouldSkip, shouldSkip = _k === void 0 ? false : _k;
    var apiConfig = useApiConfig();
    var pageState = usePageState();
    var canUseLoyalty = useAppSelector(selectCanUseLoyalty);
    var validTransmissionIds = transmissionIds.filter(Boolean);
    var transmissionId = currentTransmissionId || validTransmissionIds[0];
    var isApiConfigInvalid = Object.values(apiConfig).some(function (val) { return !val; });
    var canSkipAll = shouldSkip || isApiConfigInvalid || !validTransmissionIds.length;
    var _l = useGetOffersQuery(__assign(__assign({}, apiConfig), { transmissionIds: validTransmissionIds.join(';'), pageState: pageState }), { skip: canSkipAll }), data = _l.data, isFetching = _l.isFetching, isLoading = _l.isLoading, isSuccess = _l.isSuccess, error = _l.error;
    var loyaltyData = useGetOffersWithLoyaltyQuery(__assign(__assign({}, apiConfig), { transmissionIds: validTransmissionIds.join(';'), pageState: pageState }), { skip: canSkipAll || !canUseLoyalty }).data;
    var loyaltyOffers = ((_e = (_d = (_c = (_b = loyaltyData === null || loyaltyData === void 0 ? void 0 : loyaltyData.find) === null || _b === void 0 ? void 0 : _b.call(loyaltyData, function (i) { return transmissionId && i.transmissionKey === transmissionId; })) === null || _c === void 0 ? void 0 : _c.loyaltyOffers) === null || _d === void 0 ? void 0 : _d[paymentMethod]) !== null && _e !== void 0 ? _e : []).filter(function (item) { return LOYALTY_OFFER_TYPES_SET.has(item === null || item === void 0 ? void 0 : item.type); });
    var incentiveOffers = (_j = (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.find) === null || _f === void 0 ? void 0 : _f.call(data, function (i) { return transmissionId && i.transmissionKey === transmissionId; })) === null || _g === void 0 ? void 0 : _g.incentiveOffers) === null || _h === void 0 ? void 0 : _h[paymentMethod]) !== null && _j !== void 0 ? _j : [];
    return {
        loyaltyOffers: loyaltyOffers,
        incentiveOffers: incentiveOffers,
        isFetching: isFetching,
        isLoading: isLoading,
        isSuccess: isSuccess,
        error: error,
    };
};
export default useFetchOffers;
